import * as Sentry from '@sentry/vue';
import type { App } from 'vue';
import type { Router } from 'vue-router';

export function initSentry(app: App, router: Router) {
  const SENTRY_ACTIVE = import.meta.env.PROD;
  const DSN =
    'https://b05ac55e0d214407b72f0ed5a4611c5d@o880313.ingest.sentry.io/5840439';
  Sentry.init({
    app,
    release: import.meta.env.VITE_GIT_HASH,
    environment: import.meta.env.VITE_CUTR_ENV,
    dsn: DSN,
    enabled: SENTRY_ACTIVE,
    beforeSend(event, hint) {
      // Ignore linkedin tracker error
      if (
        (hint.originalException as Error)?.message?.includes('window.lintrk')
      ) {
        return null;
      }

      return event;
    },
    integrations: [Sentry.browserTracingIntegration({ router })],
    tracePropagationTargets: [
      'localhost',
      'http://local.cutr.com',
      'https://local.cutr.com',
      'https://api.gcp-staging.cutr.com',
      'https://api.gcp-prod.cutr.com',
      'https://api.cutr.com',
    ],
    tracesSampler: (samplingContext) => {
      // inherit parent
      if (samplingContext.parentSampled !== undefined) {
        return samplingContext.parentSampled;
      }
      return 0.25;
    },
  });
}
